import { c as _c } from "react/compiler-runtime";
import { Block } from "common/types/graphql";
import { BlocksRenderer } from "../BlocksRenderer";
import clsx from "classnames";
import type { BodyVariant } from "./node/BodyNode";
export interface BodyProps {
  blocks?: Block[];
  text?: string;
  variant: BodyVariant;
}
export const LARGE_STYLE = "mt-6 first:mt-0 mb-4 text-xl font-medium lg:mt-8 lg:text-2xl font-sans-heading";
const REGULAR_STYLE = "mb-4 font-serif lg:text-lg";
export const Body = t0 => {
  "use memo";

  const $ = _c(9);
  const {
    blocks,
    text,
    variant
  } = t0;
  const t1 = variant === "large";
  const t2 = variant !== "large";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = clsx({
      [LARGE_STYLE]: t1,
      [REGULAR_STYLE]: t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== blocks) {
    t4 = blocks && <BlocksRenderer blocks={blocks} />;
    $[3] = blocks;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4 || $[7] !== text) {
    t5 = <p className={t3}>{t4}{text}</p>;
    $[5] = t3;
    $[6] = t4;
    $[7] = text;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};